import {
  dispatchAction,
  collectRoutines,
  routine,
  extractPayload,
  ofType,
} from '@ardoq/rxbeach';
import { tagComponents } from 'streams/tags/TagActions';
import { beforeDragEnd } from 'navigator2024/handlers/dragndrop';
import { filter, tap } from 'rxjs/operators';
import { tagInterface } from '@ardoq/tag-interface';
import { componentInterface } from '@ardoq/component-interface';

const handleDragEnded = routine(
  ofType(beforeDragEnd),
  extractPayload(),
  filter(({ dropContext }) => dropContext === 'tagscape'),
  tap(({ targetDropId, ids }) => {
    const tagData = targetDropId && tagInterface.get(targetDropId);
    const tagWorkspaceId = tagData && tagData.rootWorkspace;
    const shouldTag = Boolean(
      tagWorkspaceId &&
      ![...ids].some(
        id =>
          componentInterface.isComponent(id) &&
          componentInterface.getWorkspaceId(id) !== tagWorkspaceId
      )
    );

    if (shouldTag) {
      const componentIds = new Set(
        [...ids].filter(componentInterface.isComponent)
      );
      dispatchAction(tagComponents({ tagId: targetDropId, componentIds }));
    }
  })
);

export const tagscapeRoutines = collectRoutines(handleDragEnded);
